import { Text, useToast } from '@chakra-ui/react'
import { useEffect, useMemo, useRef, useState } from 'react'
// import { errorHandle } from '../../api/api'
import { getFormRequests } from '../../classes/FormRequest'
import { useSelectedItemAlertContext } from '../../context/selectedItemAlertContext'
import { useUserContext } from '../../context/userContext'
import { BadgeFormStatus, ModalFormInfo, Table, TextDateFormat } from '../shared'
import { TableButtonApproveGroup } from '../shared'
import { toastErrDesc, toastVal } from '../../utils/toastUtils'

const TableWaitingApproveList = () => {
    const toast = useToast()
    const { userData } = useUserContext()
    const columns = useMemo(() => [
        {
            Header: '#',
            Cell: ({ row }) => (<Text>{row.index + 1}</Text>)
        },
        {
            Header: 'ชื่อ-นามสกุลผู้ยื่นคำร้อง',
            Cell: ({ row }) => (<Text>{`${row.original.requester_first_name} ${row.original.requester_last_name}`}</Text>)
        },
        {
            Header: 'อาคาร',
            accessor: 'residence_name',
        },
        {
            Header: 'วันที่ยื่น',
            accessor: 'submit_date',
            Cell: ({ value }) => <TextDateFormat value={value} />
        },
        {
            Header: 'สถานะ',
            Cell: ({ row }) => <BadgeFormStatus data={row.original} />
        },
        {
            Header: 'จัดการ',
            Cell: ({ row }) => <TableButtonApproveGroup row={row.original} />
        }
    ], [])
    const [data, setData] = useState(null)
    const { itemData } = useSelectedItemAlertContext()

    const loadData = useRef()
    loadData.current = async () => {
        await getFormRequests('', userData.token, '&form_status_id=2')
            .then(res => {
                // console.log('load data')
                // console.log(res)
                setData(res)
            })
            .catch(error => {
                // console.log('error')
                // console.log(errorHandle(error))
                toast(toastVal({
                    title: "การดึงข้อมูล ไม่สำเร็จ",
                    description: toastErrDesc(error),
                    status: "error",
                }))
            })
    }

    useEffect(() => {
        loadData.current()
    }, [itemData?.reload])

    return (
        <>
            {data && <Table columns={columns} data={data} />}
            <ModalFormInfo data={itemData} admin={true} />
        </>
    )
}

export default TableWaitingApproveList
